import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { TransactionsCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { TransactionsTable } from "./table";

export default function Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions financières");
  }, []);

  return (
    <Routes>
      <Route index element={<TransactionsTable />} />

      <Route path=":id" element={<TransactionsCard />} />
    </Routes>
  );
}
